import { memo } from 'react'
import { TAG_ICONS } from './tagIcons'
import type { FeedTag, FeedTagStyle } from '../../types/feedContract'

interface CardTagsProps {
  tags: FeedTag[]
  className?: string
}


function getTagStyles(fontStyle?: string) {
  const italic = fontStyle === 'italic' || fontStyle === 'bold-italic'
  const bold = fontStyle === 'bold' || fontStyle === 'bold-italic'
  return {
    fontStyle: italic ? ('italic' as const) : ('normal' as const),
    fontWeight: bold ? '700' : 'normal',
  }
}

export const CardTags = memo(function CardTags({ tags, className = '' }: CardTagsProps) {
  if (!tags || tags.length === 0) return null

  return (
    <div className={`card-tags ${className}`}>
      {tags.map((tag, i) => {
        const style: FeedTagStyle = tag.style || {}
        const IconComponent = style.icon ? TAG_ICONS[style.icon] ?? null : null

        return (
          <span
            key={`${tag.label}-${i}`}
            className="card-tag"
            style={{
              backgroundColor: style.background_color,
              color: style.text_color,
              ...getTagStyles(style.font_style || undefined),
            }}
          >
            {IconComponent && <IconComponent className="card-tag-icon" size={12} />}
            {tag.label}
          </span>
        )
      })}
    </div>
  )
})
